export default __webpack_public_path__ + "static/media/EAST2450.34I-34251_-18472_0.acc5a6ad.jpg";